import { api } from "./api";

// Wire contract for the integrations catalog. Types come straight from
// @memkernel/integration-kit so we never hand-mirror the shape — any
// new strategy kind or catalog field added on the server side is
// instantly available to the SPA at compile time.
export type {
  AuthStrategyKind,
  CatalogAuthKind as AuthKind,
  EventTag,
  IntegrationCatalogAuthMethod,
  IntegrationCatalogEvent,
  IntegrationCatalogRow,
  IntegrationCatalogTool,
  IntegrationCatalogVersionSummary,
  ApiKeyField,
  ToolTag,
} from "@memkernel/integration-kit";

import type { IntegrationCatalogRow } from "@memkernel/integration-kit";

// authLabel re-exported so the existing import site doesn't have to
// know it lives in the kit.
export { authLabel } from "@memkernel/integration-kit";

export const integrationsApi = {
  list: () => api<IntegrationCatalogRow[]>("/v1/integrations"),
  get: (slug: string) => api<IntegrationCatalogRow>(`/v1/integrations/${slug}`),
};
